import React, { useState, useEffect } from "react";
import "tailwindcss/tailwind.css";
import "../../style/twform.css";
import chevron from "../../images/icons/chevron.svg";

const Accordion = ({ children, title }) => {
  const [isVisible, setisVisible] = useState(false);

  return (
    <>
      <div
        className="tw-gap-4 tw-rounded-lg tw-items-center tw-p-3 "
        style={{ border: "solid 1px #E8E8E8" }}>
        <div
          className={`tw-flex tw-flex-row tw-justify-between tw-items-center`}
          onClick={() => setisVisible(!isVisible)}>
          <div className="tw-font-semibold tw-text-[16px] tw-leading-5 tw-text-[#111111] tw-w-[325px] md:tw-w-[535px]">
            {title}
          </div>
          <img src={chevron} height={24} width={24} className="tw-rotate-90" />
        </div>
        {isVisible && <div className="tw-mt-3">{children}</div>}
      </div>
    </>
  );
};

export default Accordion;
